import { Complete } from "@/components/common/Complete";
import { supabaseClient } from "@/lib/supabase";
import { randomHappyEmoji, wordsOfPraise } from "@/utils/positivePatientWords";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import dayjs from "dayjs";
import { CheckCircle2 } from "lucide-react";
import { useAuth } from "../../../../../utils/auth";

const getRandomSuccessTitle = () => {
	const titles = [
		"Patient Added Successfully!",
		"Welcome to Patient Watch!",
		"New Patient Onboarded!",
		"Patient Profile Created!",
		"Patient Successfully Registered!",
	];
	return titles[Math.floor(Math.random() * titles.length)];
};

export const Route = createFileRoute("/_app/new/diary/invite/complete")({
	component: CompletePage,
});

function CompletePage() {
	const auth = useAuth();
	const { data: diariesCount, isLoading } = useQuery({
		queryKey: ["diaries-last-7-days"],
		queryFn: async () => {
			const sevenDaysAgo = dayjs().subtract(7, "day").toISOString();
			const { data, error } = await supabaseClient
				.from("diaries_view")
				.select("diary_id")
				.eq("created_by", auth.id)
				.gte("start_date", sevenDaysAgo);

			if (error) throw error;
			return data.length;
		},
	});

	const description = isLoading
		? "Just a moment while we gather your statistics..."
		: `In the last 7 days, you have added ${
				Number(diariesCount ?? 0) + 1
			} diaries to Patient Watch. ${wordsOfPraise()} ${randomHappyEmoji()}`;

	return (
		<Complete
			title={getRandomSuccessTitle() ?? "Congratulations!"}
			description={description}
			icon={CheckCircle2}
			isLoading={isLoading}
			loadingText="Loading your achievements..."
			minLoadingTime={1000}
			primaryButton={{
				text: "Next",
				to: "/patients",
			}}
		/>
	);
}
